var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "9", md: "12", sm: "12" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Start Date",
                            "label-for": "h-Owner-name",
                            "label-cols-md": "2",
                          },
                        },
                        [
                          _c("b-form-datepicker", {
                            staticClass: "mb-1",
                            attrs: {
                              id: "startDatePicker",
                              min: new Date(),
                              disabled: _vm.JobCard.status === 1,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.startDate()
                              },
                            },
                            model: {
                              value: _vm.job.startDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.job, "startDate", $$v)
                              },
                              expression: "job.startDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Finish Date",
                            "label-for": "h-Owner-name",
                            "label-cols-md": "2",
                          },
                        },
                        [
                          _c("b-form-datepicker", {
                            staticClass: "mb-1",
                            attrs: {
                              id: "endDatePicker",
                              min: _vm.job.startDate,
                            },
                            model: {
                              value: _vm.JobCard.endDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.JobCard, "endDate", $$v)
                              },
                              expression: "JobCard.endDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Due Date",
                            "label-for": "h-Owner-name",
                            "label-cols-md": "2",
                          },
                        },
                        [
                          _c("b-form-datepicker", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            staticClass: "mb-1",
                            attrs: {
                              id: "deliveryDatePicker",
                              min: _vm.JobCard.endDate,
                              title: "Delivery Date",
                            },
                            model: {
                              value: _vm.JobCard.deliveryDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.JobCard, "deliveryDate", $$v)
                              },
                              expression: "JobCard.deliveryDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Status",
                            "label-for": "h-Owner-name",
                            "label-cols-md": "3",
                          },
                        },
                        [
                          _c("b-form-select", {
                            attrs: { options: _vm.options },
                            on: {
                              change: function ($event) {
                                return _vm.callChangeStatus()
                              },
                            },
                            model: {
                              value: _vm.job.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.job, "status", $$v)
                              },
                              expression: "job.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "5" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Bill Material Status",
                            "label-for": "h-Owner-name",
                            "label-cols-md": "5",
                          },
                        },
                        [
                          _c("b-form-select", {
                            attrs: { options: _vm.BOMOptionsStatus },
                            on: {
                              change: function ($event) {
                                return _vm.callChangeBOMStatus()
                              },
                            },
                            model: {
                              value: _vm.job.bomStatus,
                              callback: function ($$v) {
                                _vm.$set(_vm.job, "bomStatus", $$v)
                              },
                              expression: "job.bomStatus",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "4" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Operation Status",
                            "label-for": "h-Owner-name",
                            "label-cols-md": "4",
                          },
                        },
                        [
                          _c("b-form-select", {
                            attrs: { options: _vm.operationOptionsStatus },
                            on: {
                              change: function ($event) {
                                return _vm.callChangeOperationStatus()
                              },
                            },
                            model: {
                              value: _vm.job.operationStepsStatus,
                              callback: function ($$v) {
                                _vm.$set(_vm.job, "operationStepsStatus", $$v)
                              },
                              expression: "job.operationStepsStatus",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Priority",
                            "label-for": "h-Owner-name",
                            "label-cols-md": "2",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              placeholder: "This is the priority for this job.",
                              disabled: "",
                            },
                            model: {
                              value: _vm.job.priority,
                              callback: function ($$v) {
                                _vm.$set(_vm.job, "priority", $$v)
                              },
                              expression: "job.priority",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Warehouse",
                            "label-for": "h-warehouse",
                            "label-cols-md": "2",
                          },
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              placeholder: "",
                              options: _vm.optionsWarehouse,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.callChangewarehouse()
                              },
                            },
                            model: {
                              value: _vm.job.warehouseId,
                              callback: function ($$v) {
                                _vm.$set(_vm.job, "warehouseId", $$v)
                              },
                              expression: "job.warehouseId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            {
              staticClass: "d-flex align-items-center justify-content-center",
              attrs: { lg: "3", md: "12", sm: "12" },
            },
            [
              _c(
                "b-card",
                {
                  staticClass: "text-center p-3",
                  attrs: {
                    "bg-variant": "primary",
                    "body-text-variant": "info",
                  },
                },
                [
                  _c("h2", { staticClass: "text-info" }, [
                    _vm._v("Quantity In Production: "),
                  ]),
                  _c("h1", { staticClass: "text-info" }, [
                    _vm._v(_vm._s(_vm.JobCard.quantityInProduction)),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }